<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="">

    <div class="d-flex mb-5">
        <button class="btn btn-info ml-auto btn-size-normal" [routerLink]="['./', 'add-statement']" (click)="addStatement()">
            <span class="btn-inner--text" i18n>Add Statement</span>
        </button>
    </div>
    <ngx-datatable [rows]="statements" [columns]="columns" columnMode="force" [scrollbarH]="true" [rowHeight]="48">

        <ngx-datatable-column *ngFor="let col of columns; trackBy: trackColumns" [name]="col.name" [prop]="col.prop">
        </ngx-datatable-column>

        <ngx-datatable-column name="" sortable="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button i18n type="button" class="btn btn-link p-0 m-0 mr-3" (click)="oneEdit(row)">
                    <img class="row-icon" src="assets/_ionicons_svg_md-list-box.svg" />
                </button>
                <button i18n type="button" class="btn btn-link p-0 m-0" (click)="onRemove(row)">
                    <img class="row-icon" src="assets/_ionicons_svg_md-trash.svg" />
                </button>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policy-details/policy-statements-list/policy-statements-list.component.html